import http from 'axios'
import { formatFiltresToAxiosParams } from './utils/filtres.utils'

export default {
  getDocumentPdf: (username, numeroContrat) => {
    return http({
      url: `/web/v1/${username}/documents/contrats-cereales/${numeroContrat}`,
      method: 'GET',
      responseType: 'blob'
    })
  },
  getDocumentFileName: (username, numeroContrat) => {
    return http.get(`/web/v1/${username}/documents/file-name/${numeroContrat}`)
  },
  fetchContratResumeRs3ByTypePrix: (username, anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/contrats/resume/${codeGraineRs3}`)
  },
  getPrixContratMoyenComparaison: (username, anneeRecolte, codeGraineRs3, filtres) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/contrats/prix-contrat-moyens/comparaison?codeIdaRs3=${codeGraineRs3}&${formatFiltresToAxiosParams(filtres)}`)
  },
  getPrixVenteMoyenComparaison: (username, params) => {
    return http.get(`/web/v1/${username}/recoltes/${params.anneeRecolte}/contrats/prix-vente-moyens/comparaison?codeIdaRs3=${params.codeGraine}&${formatFiltresToAxiosParams(params.filtres)}`)
  },
  getAllResumeContratByAnneeAndGraine: (username, anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/${username}/contrats/resume?anneeRecolte=${anneeRecolte}&codeGraineRs3=${codeGraineRs3}`)
  },
  getDetailsContratByNumeroContrat: (username, numeroContrat, numeroOrdreContrat) => {
    return http.get(`/web/v1/${username}/contrats/${numeroContrat}/details?numeroOrdreContrat=${numeroOrdreContrat}`)
  },
  getDetailsContratAssimilePrixCampagneNonEngage: (username, anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/${username}/contrat/prix-non-engage/${codeGraineRs3}/details?anneeRecolte=${anneeRecolte}`)
  },
  getDetailsContratAssimileTresoMoissonAFixer: (username, anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/${username}/contrat/treso-moisson/a-fixer/${codeGraineRs3}/details?anneeRecolte=${anneeRecolte}`)
  },
  fetchContratsResumeGlobalRs3AnneeRecolte: (username, anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/contrats/resume-global/${codeGraineRs3}`)
  },
  getEvolutionPrixContratNumtiers: (username, anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/contrats/evolution-prix-contrat?codeIdaRs3=${codeGraineRs3}`)
  },
  getEvolutionPrixContratGroupe: (username, anneeRecolte, codeGraineRs3, filtres) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/contrats/evolution-prix-contrat/comparaison?codeIdaRs3=${codeGraineRs3}&${formatFiltresToAxiosParams(filtres)}`)
  },
  getRepartitionQuantiteCibleContratAdherent: (username, anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/contrats/repartition/adherent?codeIdaRs3=${codeGraineRs3}`)
  },
  getRepartitionQuantiteCibleContratGroupe: (username, anneeRecolte, codeGraineRs3, filtres) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/contrats/repartition/groupe?codeIdaRs3=${codeGraineRs3}&${formatFiltresToAxiosParams(filtres)}`)
  }
}
